function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.13 11.34a2.206 2.206 0 00-2.68-2.68c-.77.19-1.4.82-1.59 1.59a2.206 2.206 0 002.68 2.68c.78-.19 1.41-.82 1.59-1.59z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M6.02 17.97c-.18 0-.37-.07-.51-.2a9.545 9.545 0 01-3.05-6.98c0-5.26 4.28-9.54 9.54-9.54 5.26 0 9.54 4.28 9.54 9.54 0 2.66-1.07 5.12-3.01 6.95-.3.28-.78.27-1.06-.03-.28-.3-.27-.78.03-1.06a7.938 7.938 0 002.54-5.85c0-4.43-3.61-8.04-8.04-8.04S3.96 6.37 3.96 10.8c0 2.26.91 4.34 2.57 5.88.3.28.32.76.04 1.06a.78.78 0 01-.55.23z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16 15.3a.746.746 0 01-.54-1.26c.83-.88 1.29-2.04 1.29-3.24 0-2.62-2.13-4.74-4.74-4.74a4.75 4.75 0 00-4.74 4.74c0 1.21.46 2.36 1.29 3.24.28.3.27.78-.03 1.06-.3.29-.78.27-1.06-.03a6.229 6.229 0 01-1.7-4.27c0-3.44 2.8-6.24 6.24-6.24 3.44 0 6.24 2.8 6.24 6.24 0 1.59-.6 3.11-1.7 4.27a.78.78 0 01-.55.23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3 16.66l-1.44 1.79c-1.14 1.43-.13 3.54 1.7 3.54h2.87c1.83 0 2.85-2.12 1.7-3.54l-1.44-1.79c-.86-1.09-2.52-1.09-3.39 0z"
})));